import { useTheme } from '@mui/material/styles';

export const useStyles = () => {
  const theme = useTheme();
  return {
    footerContainer: {
      backgroundColor: theme.colors.common5,
      color: theme.colors.common15,
      '& a': {
        color: theme.colorTokens.hyperlink,
      },
    },
    hyperLink: {
      color: theme.colorTokens.hyperlink,
    },
    title: {
      fontSize: '20px',
      color: theme.colors.common15,
      fontWeight: 700,
    },
    footerWrapper: {
      padding: theme.spacing(4),
      maxWidth: '600px',
      textAlign: 'center',
      color: theme.colors.common15,
    },
    footerHelp: {
      borderBottom: '1px solid #ccc',
      borderColor: theme.colors.common5,
      '& .font-weight-demibold': {
        fontWeight: 600,
      },
    },
    footerLogoContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: theme.spacing(2),
    },
    footerLogo: {
      verticalAlign: 'middle',
      margin: '0 10px',
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    footerLogoMobile: {
      display: 'none',
      [theme.breakpoints.down('sm')]: {
        display: 'block',
      },
    },
    footerBrand: {
      fontSize: theme.spacing(3),
      verticalAlign: 'middle',
      fontWeight: 700,
    },
    copyright: {
      fontWeight: 700,
      color: theme.colors.common15,
      marginTop: theme.spacing(3),
    },
  };
};
